export enum PaymentMethod {
  Invoice = "0001",
  Prepayment = "0002",
}

export const mapToPaymentMethod = (
  paymentMethod: string | undefined,
): PaymentMethod => {
  if (Object.values(PaymentMethod).includes(paymentMethod as PaymentMethod))
    return paymentMethod as PaymentMethod;

  return PaymentMethod.Invoice;
};
